import React, { useEffect, useState } from 'react';

import { CurrentUser } from '../calendar/Calendar';
import { fromRole, ProjectModel, SbCurrentUser } from './component/SbModel';
import SubmissionBoardsCreator from './SubmissionBoardsCreator';
import SubmissionBoardsRecipient from './SubmissionBoardsRecipient';
import SubmissionBoardsPerformer from './SubmissionBoardsPerformer';
export interface SubmissionBoardsProps {
  currentUser: SbCurrentUser;
  project: ProjectModel;
  from: string;
  params: any;
  project_image_thumb: string;
  role?: string;
}
export default function SubmissionBoardsPage({
  currentUser,
  project,
  from,
  params,
  project_image_thumb,
  role,
}: SubmissionBoardsProps) {
  const [fromPage, setFromPage] = useState('');

  useEffect(() => {
    console.log('currentUser', currentUser);
    setFromPage(from);
    if (project_image_thumb != null) {
      project.project_image_thumb = project_image_thumb;
      // Add role to currentUser object
    }
    if (role) {
      currentUser.role = role;
    }
  }, [from, role]);
  return (
    <>
      {fromPage == fromRole.SB_CREATOR && (
        <>
          <SubmissionBoardsCreator
            currentUser={currentUser}
            project={project}
            params={params}
            fromPage={fromPage}
          />
        </>
      )}
      {fromPage == fromRole.RECIPIENT && (
        <>
          <SubmissionBoardsRecipient
            currentUser={currentUser}
            project={project}
            params={params}
            fromPage={fromPage}
          />
        </>
      )}
      {fromPage == fromRole.SB_PERFORMER && (
        <>
          <SubmissionBoardsPerformer currentUser={currentUser} fromPage={fromPage} />
        </>
      )}
    </>
  );
}
